<div class="td-slider">
  <label class="td-wb-range-slider__label"
         [attr.for]="inputForAttr()"
         #valueIndicator
         [style.--min]="min()"
         [style.--max]="max()"
         [style.--value]="value()"
         [ngClass]="{'td-slider-label-top': labelPosition() === 'top' , 'td-wb-hide': labelPosition() === 'none'}"
         [innerText]="getFormatted(value())"></label>
  <ng-content select="input[tdWbRangeInput]" />
  @if (showLabels()) {
    <div class="td-slider-labels">
      <span class="td-wb-range-slider__min"
            [innerText]="getFormatted(min())"></span>
      <span class="td-wb-range-slider__max"
            [innerText]="getFormatted(max())"></span>
    </div>
  }
</div>
